import { ChevronRightRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
const HeroSection = () => {
  function launchDemo() {
    window.open(
      "https://assessive.net/Microsoft%20Azure%3A%20Fundamentals/",
      "_blank",
    );
  }

  return (
    <section id="home">
      <div className="hero-text">
        <div>
          <h1 className="no-cap">
            Build Customs Exams & Flashcards. <br />
            The Open-Source Study Platform that Adapts to You.
          </h1>
          <p>
            Assessive is a powerful, community-driven platform designed to help
            you study smarter. Create personalized quizzes, memorize faster with
            flashcards, and use insightful metrics to focus your efforts without
            spending a dime.
          </p>
        </div>
        <div>
          <Button
            size="medium"
            className="px-4 py-2"
            endIcon={<ChevronRightRounded />}
            sx={{
              background: "var(--redGradient)",
              transition: "all 0.2s linear",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
            variant="contained"
            disableElevation
            onClick={launchDemo}
          >
            Try Demo
          </Button>
        </div>
      </div>
      <div className="hero-images">
        <img src="/landing-art.svg" alt="desktop, mobile, and tablet views" />
      </div>
    </section>
  );
};

export default HeroSection;
